import { media } from 'designsystem/index';
import Arrow from 'blocks/Arrow/Arrow';
import { keyframes } from 'styled-components';

const activeAnimation = keyframes`
  0% {
    transform: scale(0.95) translateX(3px) rotate(135deg);
  }

  50% {
    transform: scale(1.05) translateX(-2px) rotate(135deg);
  }
  
  100% {
    transform: scale(0.95) translateX(3px) rotate(135deg);
  }
`;

const ArrowLeft = Arrow.extend`
  position: absolute;
  right: -16px;
  transition: right 0.25s;
  transform: rotate(135deg);
  margin-right: 29px;
  
  animation: ${({ animate }) => (animate ? `${activeAnimation} 1.75s ease-in-out infinite` : 'none')};
  
  ${media.desktop`
    right: -2px;
    transform: rotate(135deg);
  `};  
`;

export default ArrowLeft;



// WEBPACK FOOTER //
// ./src/blocks/SliderButtons/ArrowLeft.jsx